import { AppEnvironmentFull } from '@mitsubishi/shared/data-access';

function parseBool(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === '') return fallback;
  return value === 'true' || value === '1';
}

function env(key: string): string | undefined {
  if (typeof window !== 'undefined' && window.__env) {
    return window.__env[key];
  }
  return undefined;
}

export const environment: AppEnvironmentFull = {
  production: parseBool(env('PRODUCTION'), false),
  env: (env('ENV_NAME') as AppEnvironmentFull['env']) || 'dev',
  apiServerUrl: env('API_SERVER_URL') || 'v1/applyme',
  wsServerUrl: env('WS_SERVER_URL') || 'wss://apiws.dev.melcoapplyme.com/ws',
  keycloakConfig: {
    url: env('KEYCLOAK_URL') || 'https://auth.dev.melcoapplyme.com/auth/',
    realm: env('KEYCLOAK_REALM') || 'applyme',
    clientId: env('KEYCLOAK_CLIENT_ID') || 'applyme-fe',
  },
  disableCompanies: parseBool(env('DISABLE_COMPANIES'), false),
  disableProjectList: parseBool(env('DISABLE_PROJECT_LIST'), false),
  disableSelectionList: parseBool(env('DISABLE_SELECTION_LIST'), false),
  disableEnergyAnalyses: parseBool(env('DISABLE_ENERGY_ANALYSES'), false),
  isWorkingEnv: parseBool(env('IS_WORKING_ENV'), false),
  sentry: {
    enabled: parseBool(env('SENTRY_ENABLED'), false),
    dsn: env('SENTRY_DSN') || '',
    tracePropagationTargets: [],
  },
};
